export default {
  namespaced: true,
  employees: {
    title: 'Employees | Employee',
    first_name: 'name',
    last_name: 'last name',
    employee_id: 'Employee ID',
  }
}
